import { render } from "./VecinosAlLimite.vue?vue&type=template&id=acb5eeae&scoped=true"
import script from "./VecinosAlLimite.vue?vue&type=script&lang=js"
export * from "./VecinosAlLimite.vue?vue&type=script&lang=js"

import "./VecinosAlLimite.vue?vue&type=style&index=0&id=acb5eeae&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-acb5eeae"]])

export default __exports__